<template>
  <div class="wrapper">

    <div class="downloadTopcontent">
      <img :src="downloadData.download_page_bg_image_pc" class="backgroundImg" width="fit-content" height="400px"/>

      <div class="logoImg">
        <img :src="downloadData.download_page_logo"  width="fit-content" height="120px" st/>

        <p class="titleText">{{$t(this.downloadData.download_page_title)}}</p>

        <p class="subTitleText">{{$t(this.downloadData.download_page_subtitle)}}</p>

      </div>
    </div>
     <div class="buttonContent">
        <span @click="showPopup('ios')" class="iphoneButton" ><img style="height: 15px; width: 15px; margin-right: 10px; margin-bottom: 2px;" src="../assets/img/icon1.png">{{$t('appdownload.iphone')}}</span>
        <span @click="showPopup('android')" class="androidButton" ><img style="height: 15px; width: 15px; margin-right: 10px; margin-bottom: 2px;" src="../assets/img/icon2.png">{{$t('appdownload.android')}}</span>
        <span @click="showPopup('iostf')" class="iphoneButton" v-if="downloadData.app_iostf" ><img style="height: 15px; width: 15px; margin-right: 10px; margin-bottom: 2px;" src="../assets/img/icon1.png">{{$t('appdownload.iostf')}}</span>
        <span @click="showPopup('microsoft')" class="windowsButton" v-if="downloadData.app_microsoft" ><img style="height: 15px; width: 15px; margin-right: 10px; margin-bottom: 2px;" src="../assets/img/microsoft.png">{{$t('appdownload.microsoft')}}</span>

      </div>
    <el-dialog id="dialogStyle" :visible.sync="qrPopup" width="450px" center>
      <div class="img-box">
        <div id="downloadQrCodeSecond"></div>
        <p class="img-box-title">{{ popupContent }}</p>
      </div>
    </el-dialog>

    
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  name: "download",
  data() {
    return {
      info: {
        qq: [],
        phone: [],
        codes: [],
      },
      qrPopup: false,
      appDownload: "",
      popupContent: "",
      qrCode: null,
      hk_android: "",
      hk_apple: "",
      downloadData: {
        app_android: "",
        app_app: "",
        app_ios: "",
        download_page_bg_image_app: "",
        download_page_bg_image_pc: "",
        download_page_logo: "",
        download_page_title: "",
        download_page_subtitle: "",
      }
    };
  },
  computed: {},
  methods: {
    showPopup(operate) {
      switch (operate) {
        case "android":
          this.qrPopup = true;
          this.popupContent = this.$t('download.android');
          setTimeout(() => {
            this.QrCode(this.downloadData.app_android);
          }, 300);
          break;
        case "ios":
          this.qrPopup = true;
          this.popupContent = this.$t('download.appleversion');
          setTimeout(() => {
            this.QrCode(this.downloadData.app_ios);
          }, 300);
          break;
          case "microsoft":
          this.qrPopup = false;
          this.popupContent = this.$t('download.microsoftVersion');
          window.open(this.downloadData.app_microsoft)
          // setTimeout(() => {
          //   this.QrCode(this.downloadData.app_microsoft);
          // }, 300);
          break;
          case "iostf":
          this.qrPopup = true;
          this.popupContent = this.$t('download.iosTfVersion');
          setTimeout(() => {
            this.QrCode(this.downloadData.app_iostf);
          }, 300);
          break;
        default:
          break;
      }
    },
    QrCode(url) {
      if (this.qrCode) {
        this.qrCode.makeCode(url);
      } else {
        this.qrCode = new QRCode("downloadQrCodeSecond", {
          width: 345,
          height: 345,
          text: url, // 二维码地址
        });
      }
    },
    getInfoData() {
      let that = this;
      that
        .$http({
          url: "/app/Sysconfig/web_common",
          method: "post",
          data: {
            
          },
        })
        .then(function (res) {
          if (res.data.status == 200) {
            var data = res.data.data;
            that.info = data;
            that.appDownload = that.info.codes[0].code;
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    getQRLink() {
      let that = this;
      that
        .$http({
          url: "/app/Sysconfig/sysconfig/action",
          method: "post",
          data: {
            action: "download_link",
          },
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.hk_android = res.data.data.hk_android;
            that.hk_apple = res.data.data.hk_apple;
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    getDownlowdpageData() {
      let that = this;
      that
        .$http({
          url: "/admin/Baseconfig/downloadPage",
          method: "post",
          data: {
            
          },
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.downloadData = res.data.data;
            // console.log(that.downloadData);
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
  },
  mounted: function () {
    // this.getInfoData();
    // this.QrCodeSecond();
    // this.getQRLink();
    this.getDownlowdpageData();
  },
};
</script>

<style scoped>
.wrapper {
  /* background: url(../assets/img/bg.png) no-repeat center; */
  /* background-size: cover;
  background-position: 5% 70%; */
  min-width: 1000px;
  height: 100vh;
  background-color: #F4F4F8;
  padding-bottom: 200px;
  
}

.downloadTopcontent{
  height: 60vh;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  
}
.backgroundImg {
  pointer-events: none;
  position: absolute;
  z-index: 0;
}

.logoImg{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.titleText{
  margin: 10px;
  font-size: 20px;
  font-weight:bold;
  color: black;
}


.subTitleText{
  margin: 30px;
  font-size: 30px;
  font-weight: bold;
  z-index: 1;
}

.iphoneButton{
  border-radius: 30px;
  width: 200px;
  margin: 10px;
  padding: 16px;
  background-color: #202020;
  color: white;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
}

.androidButton{
  border-radius: 30px;
  width: 200px;
  margin: 10px;
  padding: 16px;
  background-color: #67c23a;
  color: white;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
}

.windowsButton{
  border-radius: 30px;
  width: 200px;
  margin: 10px;
  padding: 16px;
  background-color: #ebb94f;
  color: white;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
}


.buttonContent{
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  margin-top: 30px;
}

.img-box {
  width: 100%;
  opacity: 0.85;
  background: white;
  /* margin: 200px auto; */
  /* padding-top: 20px; */
}
.img-box img {
  width: 100%;
}
.img-box-title {
  text-align: center;
  font-size: 25px;
  padding: 28px 0px 0px 0px;
}

/*.img-box-second {
  width: 400px;
  opacity: 0.85;
  background: white;
  margin: 200px auto;
  padding-top: 20px;
}
.img-box-titl-second {
  text-align: center;
  font-size: 25px;
  padding: 10px 0;
} */

.tm-ic {
  display: inline-block;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
  width: 40px;
  height: 40px;
}

.ffic-android {
  background-image: url(../assets/img/icons/ffic-android.png);
}

.ffic-iphone {
  background-image: url(../assets/img/icons/ffic-iphone.png);
}

.windows {
  background-image: url(../assets/img/icons/windows.png);
}

.mac {
  background-image: url(../assets/img/icons/mac.png);
}

.buttonStyle {
  display: flex;
  margin: 20px 10px;
  background-color: #FFFFFF;
  padding: 30px;
  border-radius: 20px;
  width: 100%;
  /* width: 200px;
  height: 200px; */
  height: 200px;
  align-items: center;
}

.btn-section {
  /* background-color: #ffffff; */
  padding: 20px 20px 0px 20px;
  width: 90%;
  height: fit-content;
}
.mid-btn {
  text-align: center;
  padding: 10px 40px;
  background-color: var(--baseColor);
  border-radius: 20px;
}
.btn-name {
  color: #14141d;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
}
</style>

<style>
#dialogStyle .el-dialog__body {
  padding: 25px 25px 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/download.vue